import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { ConfirmationService } from 'primeng/api';
import { UserService } from 'app/rest/user.service';
 import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { DocumentationService } from 'app/modules/vehicle-inventory/services/documentation.service';
import { Subscription } from 'rxjs';
import { RestExt } from 'app/services/rest-client-extension';
import { DocNoteComponent } from '../doc-note/doc-note.component';
import { DocDriverLicenseComponent } from '../doc-driver-license/doc-driver-license.component';
import { DocDriverPointsComponent } from '../doc-driver-points/doc-driver-points.component';
import { DriverpointsService } from 'app/modules/vehicle-inventory/services/driverpoints.service';
import { NoteService } from 'app/modules/vehicle-inventory/services/note.service';
import { Rest } from 'app/rest/rest_client';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { VehicleService } from 'app/rest/vehicle.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { InsuranceService } from 'app/modules/vehicle-inventory/services/table-management/insurance.service';
//import { resolve } from 'path';
@Component({
    selector: "app-upload-documents-form",
    templateUrl: "./upload-documents-form.component.html",
    styleUrls: ["./upload-documents-form.component.scss"],
    providers: [DriverpointsService, NoteService, ExcelService, InvVehicleService, InsuranceService] //DocumentationService,
    ,
    standalone: false
})
export class UploadDocumentsFormComponent extends  EntityFormComponent<Rest.InvDocument> implements OnInit {

//   @ViewChild('docNote') docNote: DocNoteComponent;
//   @ViewChild('docDriverLicense') docDriverLicense: DocDriverLicenseComponent;
//   @ViewChild('docDriverPoints') docDriverPoints: DocDriverPointsComponent;

  @Output() refreshTable: EventEmitter<void> = new EventEmitter<void>();
  @Input() renewalType: string;
  @Input() title: string;
  files: { name: string; processed: boolean; message: string; correct: boolean, filemap:File }[] = [];
  filesexcel: { name: string; processed: boolean; message: string; correct: boolean}[] = [];
   isDialogVisible=false;
  optionsFilterType: any[];
  documentFile: any;
  folder:any;
  generateSpinner: boolean = false;
  disabledgenerate: boolean =true;
  isDownloadGranted: boolean = false;
  buttongenerate:string ='Generate';
  columnsCount: number;
  columns: any[];
  selectedColumns:any[];
  headers:any[];
  processedCount: number = 0;
  invvehicleservice: InvVehicleService;
  insuranceservice: InsuranceService;
  documentService: DocumentationService;
  excelService: ExcelService;
  document: Rest.InvDocument = null;
  //driverPoints: Rest.InvDriverPoints;
  note: Rest.InvNote;
  fileName ="";
  disabled = false;

  tableData: any;
  tableDataFormatted: any; //data transformed to clasic json 
    constructor(
        protected documentationService: DocumentationService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        protected authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        private translate: TranslateService,
        invVehicleService: InvVehicleService,
        insuranceservice:InsuranceService,
        excelservice:ExcelService
    ) {
        super(documentationService,notificationsService,i18n,authenticationService)
        this.invvehicleservice= invVehicleService;
        this.insuranceservice = insuranceservice;
        this.documentService = documentationService;
        this.excelService= excelservice;
    }

  ngOnInit() {
      super.ngOnInit();
      this.setPermissions();
      this.documentFile = null;
      this.folder = null;
      this.disabled = false;
      this.setColumns();
  }
  public showDialog( ){
     this.display = true;
    }
   setPermissions() {
    const user = this.authenticationService.user;
    this.isDownloadGranted = this.authenticationService.isRoleGranted('INV_INSURANCE_DOC_DOWNLOAD', user);

}
   public changeFolder(event: any) {
    if (!this.isDownloadGranted) {
        return;
    }

    const input = event.target as HTMLInputElement;
	if (input.files && input.files.length > 0) {
		this.folder = {
            name: input.files[0].webkitRelativePath.split('/')[0], // Nombre de la carpeta
            files: Array.from(input.files), // Archivos en la carpeta
		};
        this.loadFilesFromFolder(this.folder);
	}
    }


    loadFilesFromFolder(selectedFolder: any): void {
        this.disabledgenerate = false;
        this.files = selectedFolder.files.map((file: File) => ({        
            name: file.name,           // Nombre del archivo
            processed: false,          // Estado inicial como no procesado
            correct: false,
            message: this.translate.instant('events.pending'),      // Mensaje inicial
            filemap: new File([file], file.name, {
                type: file.type,
                lastModified: file.lastModified
            }) // Nuevo objeto File sin `webkitRelativePath`
        }));

        this.tableData = this.files;
      }
    
  closeFormDialog(): void {
    this.display = false;
    this.refreshTable.emit();
  }
  protected beforeShow(): void {
    this.generateSpinner = false;
    this.disabledgenerate = true;
    this.buttongenerate= this.translate.instant('logistics.orders.importExcel.generate');
    if (this.folder)
    {
        this.files=[];
        this.loadFilesFromFolder(this.folder);
    }
}
process(){
    if (!this.isDownloadGranted) {
        return;
    }

    this.disabledgenerate = true;
    this.generateSpinner = true;
    this.processedCount = 0;
    let that = this;
    //Hay que subir todos los archivos uno a uno y marcar como guardado o no.
    this.files.forEach((file, index) => {
      //  setTimeout(() => {
                let processed = false;
                let message ='';
                let arg0:Rest.ListPaginationRequest;
                arg0=RestExt.firstPageRequest();
                let name = file.name.split(".")[0];
                arg0.filters.name=[name];
                //primero hacemos un get vehicles para ver los datos que sean correctos.
                this.invvehicleservice.getPage(arg0)
                .then (
                    function(response){
                        if ((response==null)||(response.entities == null)||(response.entities.length == 0))
                        {//QUE NO EXISTA EL VEHÍCULO
                            that.assig_information(that.translate.instant('control-panel.vehicles.wrongPlate'),false,true,file);
                        }
                        else
                        {
                            let dateNow =new Date();
                            let vehicle = response.entities[0];
                            if (vehicle.insurance == null)
                            {//QUE NO TENGA SEGURO
                                that.assig_information(that.translate.instant('tableManagement.noInsurance'),false,true,file);
                            }
                            else
                            {
                                if (vehicle.insurance.disabledDate != null)
                                {//-QUE TENGA SEGURO Y QUE NO ESTÉ ACTIVO (FECHA BAJA NO NULA) 
                                    that.assig_information(that.translate.instant('tableManagement.insurance.insurancenoactived'),false,true,file);
                                }
                                else
                                {
                                    if ((vehicle.insurance.disabledDate== null) && (vehicle.insurance.endDate <= dateNow))
                                    { //-QUE TENGA SEGURO Y QUE NO ESTÉ CADUCADO (FECHA BAJA NULA Y FECHA FIN MENOR QUE FECHA ACTUAL)
                                        that.assig_information(that.translate.instant('tableManagement.insurance.insurancelapsed'),false,true,file);
                                    }
                                    else
                                    {
                                        let documentData = {
                                            id: 0,
                                            name: name,
                                            type: "INSURANCE",
                                            document: null,
                                            vehicle: {"id":vehicle.id},
                                            driver:  null,
                                            disabled: false
                                        };
                            
                                        let dataString = JSON.stringify(documentData);
                            
                                      //  const promise = new Promise<void>((resolve, reject) => {
                                            that.documentService.createDocument(dataString, file.filemap)
                                                .then(
                                                    function (response) {
                                                        that.document = response;
                                                        //add document to insurance
                                                        that.insuranceservice.createDocument(vehicle.insurance.id, that.document.id);
                                                        that.documentService.triggerRefreshList({ type:"INSURANCE", newDoc: that.document.id });
                                                        that.assig_information(that.translate.instant('general.okprocessed'),true,true,file);
                                                        //     that.isEditingDisabled = false;
                                                    //    that.isDialogVisible = false;
                                                  //      that.refreshTable.emit();//preguntar xavi porqué esto estaba comentado no pasa por el evento closeFormDialog
                                                    },
                                                    function (error) {
                                                        console.log('The request failed: ' + error);
                                                        that.assig_information(that.translate.instant('administration.deleteErrors.unknownError'),false,true,file);
                                                       // resolve();
                                                    },
                                                )
                                                .catch(function (reason) {
                                                    console.log('Catched: ' + reason);
                                                    that.assig_information(that.translate.instant('administration.deleteErrors.unknownError'),false,true,file);
                                                    //resolve();
                                                });
                                       // });
                                    }   
                                }
                            }
                        }
                    },
                    function (error)
                    {
                        console.log(error);
                        that.assig_information(that.translate.instant('control-panel.vehicles.wrongPlate'),false,true,file);
                       // resolve();
                    }
                )
                .catch(function (reason){
                    that.assig_information(that.translate.instant('control-panel.vehicles.wrongPlate'),false,true,file);
                    console.log(reason);
                   // resolve();
                })
           //  }, index * 3000); // Procesa cada archivo con un retraso
        });
}

assig_information(message,correct,processed,file)
{
    file.processed = processed;
    file.message = message;
    file.correct = correct;
    this.processedCount++;
    if (this.processedCount === this.files.length) {
        this.onProcessingComplete();
    }
}
onProcessingComplete()
{
    this.generateSpinner = false;
    this.disabledgenerate = false;
}

setColumns() { 
    let headerValue = '';
    this.headers=[];
    this.columns = [];
    this.columns.push({
        field: 'name',
        header: this.translate.instant('general.name'),
        type: 'string',
        excel: true,
    });
    this.columns.push({
        field: 'processed',
        header: this.translate.instant('general.processed'),
        type: 'boolean',
        excel: true,
        excelType: 'b',
    });
    this.columns.push({
        field: 'correct',
        header: this.translate.instant('general.correct'),
        type: 'boolean',
        excel: true,
        excelType: 'b',
    });
    this.columns.push({
        field: 'message',
        header: this.translate.instant('general.observations'),
        type: 'string',
        excel: true,
    });
    this.columnsCount = this.columns.length;
    this.selectedColumns = this.columns;
}

exportExcel() {
     let fileNameTitle = this.translate.instant('tableManagement.insurance.insurancedocumentexcel');
     this.excelService.exportExcelWithColumnsMetadata(fileNameTitle, this.selectedColumns,this.files);
   }
}


